import { useEffect } from 'react';

const useScript = (scriptContent, condition = true) => {
  useEffect(() => {
    if (condition) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = scriptContent;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [scriptContent]);
};

export const useLoadScript = (src, action) => {
  useEffect(() => {
    const { onLoad, onDestroy } = action || {};
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    if (onLoad) script.onload = onLoad;
    document.head.appendChild(script);

    return () => {
      if (onDestroy) onDestroy();
      document.head.removeChild(script);
    };
  }, [src]);
};

export default useScript;
